<template>
  <div
      class="flex flex-col max-w-md bg-gray-100 border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">

    <NuxtLinkWithLocale :to="props.link" :target="props.linkTarget">
      <TsImage class="rounded-t-lg" v-if="props.image" :src="props.image" alt="" loading="lazy"/>
    </NuxtLinkWithLocale>


    <NuxtLinkWithLocale :to="props.link" :target="props.linkTarget" class="px-4 pt-4">
      <TsTypography variant="h2" class="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
        {{ props.title }}
      </TsTypography>
    </NuxtLinkWithLocale>

    <p class="mb-3 font-normal text-gray-700 dark:text-gray-400 px-4">
      {{ props.description }}
    </p>
    <NuxtLinkWithLocale :to="props.link" :target="props.linkTarget" class="mt-auto mx-4 mb-4">
      <TsButton outlined block label="View Deal" icon="bitcoin-icons:arrow-right-filled" size="sm">
        {{useTranslation('viewDeal' , 'Bekijk aanbieding')}}
        <TsIcon name="bitcoin-icons:arrow-right-filled"></TsIcon>
      </TsButton>
    </NuxtLinkWithLocale>
  </div>

</template>
<script setup lang="ts">
import { useTranslation } from "~/composables/useTranslation";

type Props = {
  image?: string
  title?: string
  description?: string
  link: string
  linkTarget?: string
};

const props = withDefaults(defineProps<Props>(), {
  image: "/images/deal-img-1.webp",
  title: "Deal Title",
  description: "This is the deal description",
});

</script>